<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <div class="service-content">
      <div class="content">
        <div class="title-name">智慧社区解决方案</div>
        <div class="title-sub">概述</div>
        <div class="text">
          “智慧社区”既是社区建设的一种思考理念，也是新形势下社区公共服务的一种新模式。“智慧社区”以智慧、人文、服务为理念，以“治理精细化、服务人文化、手段信息化、运营智慧化” 为建设思路，以统筹各类服务资源为切入点，以满足政府、居民、商家的需求为落脚点，以信息化技术手段为支撑，构建智慧的现代新型社区。
        </div>
        <div class="title-sub">解决方案</div>
        <div class="text">
          橡诺科技智慧社区解决方案是在充分运用移动互联网、物联网、大数据、云计算等现代科学技术的基础上，整合社区人、地、房、物、事、情、组织等信息，统筹社会治理、社区服务和商业服务等资源，以智慧社区公共服务管理平台为载体，实现新型、智慧的社区治理和社区服务创新模式。解决方案涵盖社区基础网络设施建设、社区网格化治理、社区地理信息、社区电商、智慧家居、智慧物业、社区养老、社区金融和等诸多领域。解决方案总体建设框架可以概括为“1库、2平台、3位1体、多项应用”，如下图所示：
          <div class="img"><img src="@/assets/img/solution/16/1.png"></div>
            1库：智慧社区基础信息资源库<br>
            智慧社区信息化建设需要一个坚实的基础--基础信息资源库。基础信息资源库包括基础信息库和业务信息库。其中，基础信息库按照国家“一数一源、多元采集，共享校核、及时更新、权威发布”的原则建设；业务信息库则要按照“物理分散、逻辑集中、共享校核”的原则建设。基础信息资源库是上层数据共享平台、大数据分析平台，以及诸多业务应用子系统的数据来源中心及数据信息的互通互联的基础。<br><br>
            2平台：数据共享交换平台、大数据分析平台<br>
            数据共享交换平台<br>
            数据共享交换平台是智慧社区数据集成及数据交换共享的核心路由点，连接着社区基础信息资源库与社区人、地、房、物、事、情、组织等数据的通讯及交换，是保证信息完整、可靠、有效、安全传输的主要技术实现平台，承载着智慧社区参与角色、对象之间的数据信息收集与交换共享需求。<br>
            大数据分析平台<br>
            大数据分析平台利用社区基础信息资源数据仓库，以数据互联互通、信息共享和业务协同为抓手，通过智慧社区地理信息（GIS）及可视化大数据分析工具，提升社区管理人员宏观决策能力，实现社区管理信息从分散到集中，政务服务从被动到主动，决策从经验化到智能化，综合提高政府在社会治理的科学管理水平。<br><br>
            3位1体：社区治理、社区服务、居民服务<br>
            社区治理<br>
            通过整合社区人、地、房、物、事、情、组织等信息，以智慧社区公共服务管理平台为载体，实现智慧化社区治理创新。具体体现为，将城市管理辖区按照一定的标准划分成为单元网格，使整个基层管理的结构形成网状化的结构，在此基础上建立统一的信息化平台，整合了社会管理的方方面面基础数据，最终形成政务资源、居民自治联动机制，统一为政府提供高效快捷的社区治理和管理服务。<br><br>
            社区服务<br>
            一方面，以信息惠民为出发点，主要通过智慧社区网上办事大厅等方式，实现线上与线下政府机构对接，为社区居民办理政府业务过程的事前、事中、事后提供一体化支撑服务。事前提供全面的办事指南、办事预约、在线咨询、交通指引等服务；事中提供网上业务自助办理、办事信息核对、办事进度查询等服务；事后提供服务评价、结果查询等服务。让老百姓少跑腿，让数据多跑路。<br>
            另一方面，通过整合社区业务应用系统和物业行业数据信息，建立统一的社区物业服务平台，为物业、业主、商户、政府提供统一的社区物业服务管理平台。<br><br>
            居民服务<br>
            将家居环境、家具家电、家庭活动整体纳入设计范围，形成以人文生活为主体的智慧家居服务平台，通过平台服务实现房屋管理、家居控制、信息生活、人文关怀四个层面智慧家居服务，居民更可以通过移动终端设备完成家居控制。智慧家居服务平台基于橡诺自有产品移动物联网中间件开发，可以实现各类智能家居设备的统一接入、统一管理、统一控制。<br><br>
            多项应用<br>
            网格化服务与管理系统<br>
            网格化管理将城市管理辖区按照一定的标准划分成为单元网格，使整个基层管理的结构形成网状化的结构。在此基础上建立统一的信息化平台，整合了社会管理的方方面面基础数据，包括人、事、物、场所、机构等。然后通过拓展信息录入渠道，比如短信、电话、门户、平安队员上门走访、其它治安、司法、信访等数据接口，纳入了基层民情，同时建立民情分析机制。最终整合社会管理相关部门资源，形成政务资源联动机制，统一为社会提供管理服务功能。<br><br>
            物业综合管理信息系统<br>
            物业综合管理主要通过社区智能化的系统建设和集成，例如驻场体验中心、智能停车场、视频监控、一卡通系统、数字报修报检、移动巡逻、代缴代扣、电梯管理、远程抄表、可视化GIS管理调度、自动喷淋等，改变传统物业服务效率低下、商业模式陈旧的弊端，不仅让社区居民感受到更优质的服务，也拓展了物业服务经营收益，最重要的能提升物业管理水平和企业形象。<br><br>
            智慧家居系统<br>
            智慧家居是以住宅为载体，通过物联网技术将家中的各种设备连接到一起，提供空间设计、网络通讯、信息家电、设备自动化、家居服务、家居管理等多种功能，为居民提供高效、舒适、便利、环保的居住环境。<br><br>
            电商服务系统<br>
            社区商业服务以O2O业务形态为基础，全方位整合了周边商家、商超团购、垂直电商和家政服务等不同的社区商业服务提供者，为社区居民带来更便捷的购物体验，满足社区居民吃穿住行游购娱教全方位需求。
          </div>
        <div class="title-sub">功能架构</div>
        <div class="text">
          智慧社区从应用层面以社区综合服务平台为核心，其功能架构如下图所示：
          <div class="img"><img src="@/assets/img/solution/16/2.png"></div>
        </div>
        <div class="title-sub">核心能力</div>
        <div class="text">
          智慧社区咨询与规划能力 <br>
          橡诺科技具备全方位、多领域的规划和整合能力。从源头顶层规划开始，以先进的智慧社区指标体系为依据，以社区的绿色可持续发展为目标，以社区居民服务满意为己任，充分考虑到每个社区的特点，从顶层规划设计上为社区的发展提供源头保障，可为客户提供具有个性化社区特点的、可持续发展的智慧社区顶层设计。<br>
          智慧社区建设与实施能力<br>
          橡诺科技在智慧社区耕耘多年，积累了丰富的实施方经验，形成了包括智慧社区公共服务管理、社区网格化管理、社区电商服务、社区养老、智慧家居等系列方案模块，锻炼了一支经验丰富的千人的实施团队，可为智慧社区建设和实施提供了技术、人员、项目管理等全方位的保障。<br>
          智慧社区持续运营能力<br>
          橡诺科技在智慧社区设计和规划时就注入“可持续运营”的理念，通过打造社区周边15分钟生活圈、社区电商、社区金融、社区养老等服务，实现社区建设的可持续运营，构建良好的社区微城市圈。<br>
          打造全产业链服务，构建创新型智慧社区服务生态体系；橡诺科技一方面携手权威研究机构、国内外优秀的咨询公司、世界知名的软硬件合作伙伴；另一方面根据当地社区的特点，与社区周边商家、社区服务提供商、市政服务提供商等，共同构筑创新型智慧社区服务生态体系。
        </div>
        <div class="title-sub">客户收益</div>
        <div class="text">
          橡诺科技智慧社区的建设围绕政府、社区居民、商家、物业等主体，构建社区生态体系，探索社区治理与社区公共服务新模式。<br>
          政府：通过网格化管理，创新社区服务管理理念与模式，整合公共服务信息资源，改进公共服务提供方式，减少基层工作者繁杂而重复的工作，提高工作整体效率和质量，为社区居民提供更加便捷、透明、高效、亲和的政务服务。<br>
          开发商/物业：运用信息化手段帮助开发商和物业进行互联网转型。首先能帮助提升物业管理效率，降低物业管理成本；其次提升整体服务水平、拓展多样化社区服务，增加盈利；此外，能充分建立起用户黏性，增强与用户的沟通，提升用户的满意度，提升品牌。<br>
          居民：建立触手可及、惠及全民、功能恰当的新型社会服务体系，为居民提供敏捷、主动、精准的服务，进一步优化社区居民安全、便利、舒适、愉悦的智慧化生活方式，提升公众幸福感。
        </div>
      </div>
      <Mission/>
    </div>

    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/solution-banner.jpg"),
        title: "为您提供专业的解决方案",
        sub: "专业的服务 高效的方案"
      }
    }
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        color: #333;
        line-height: 24px;
        font-size: 20px;
        text-align: left;
        box-sizing: border-box;
        width: 200px;
        margin-top: 30px;
        margin-bottom: 10px;
        border-radius: 30px;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        .img{
          padding: 30px;
          margin: 20px auto;
          background: #fff;
          text-align: center;
        }
      }
    }
}
</style>